export const PHILIP_SNAT_LEAGUE_NAMES: Record<string, string> = {
  EPL: 'Premier League',
  ELC: 'Championship',
  LALIGA: 'La Liga',
  SERIEA: 'Serie A',
  BUNDESLIGA: 'Bundesliga',
  LIGUE1: 'Ligue 1',
  EREDIVISIE: 'Eredivisie',
  LIGAPT: 'Liga Portugal',
  JPL: 'Jupiler Pro League',
  SUPERLIG: 'Süper Lig',
  GRSL: 'Super League Greece',
  AUTBL: 'Austrian Bundesliga',
  SUISL: 'Swiss Super League',
  SPFL: 'Scottish Premiership',
  HNL: 'HNL',
  BULFPL: 'First Professional League',
  ROUL1: 'Liga 1',
  EGYPL: 'Egyptian Premier League',
  UAEPL: 'UAE Pro League',
  ALLSV: 'Allsvenskan',
  ELITE: 'Eliteserien',
  BESTA: 'Besta deild',
  CHIPD: 'Primera División',
};

export const leagueLabel = (code: string): string => PHILIP_SNAT_LEAGUE_NAMES[code] ?? code;

export const isSoccerLeague = (code: string): boolean => code in PHILIP_SNAT_LEAGUE_NAMES;
